"use strict";
// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_select_1 = tslib_1.__importStar(require("rc-select"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var SizeContext_1 = tslib_1.__importDefault(require("../config-provider/SizeContext"));
var index_1 = tslib_1.__importDefault(require("../info-boundary/index"));
var iconUtil_1 = tslib_1.__importDefault(require("./utils/iconUtil"));
var SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
var InternalSelect = function (_a, ref) {
    var _b, _c;
    var customizePrefixCls = _a.prefixCls, _d = _a.bordered, bordered = _d === void 0 ? true : _d, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, _e = _a.listHeight, listHeight = _e === void 0 ? 256 : _e, _f = _a.listItemHeight, listItemHeight = _f === void 0 ? 24 : _f, customizeSize = _a.size, notFoundContent = _a.notFoundContent, _g = _a.transitionName, transitionName = _g === void 0 ? 'slide-up' : _g, loading = _a.loading, props = tslib_1.__rest(_a, ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "listHeight", "listItemHeight", "size", "notFoundContent", "transitionName", "loading"]);
    var _h = React.useContext(config_provider_1.ConfigContext), getContextPopupContainer = _h.getPopupContainer, getPrefixCls = _h.getPrefixCls, renderEmpty = _h.renderEmpty, direction = _h.direction, virtual = _h.virtual, dropdownMatchSelectWidth = _h.dropdownMatchSelectWidth;
    var size = React.useContext(SizeContext_1.default);
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    var mode = React.useMemo(function () {
        var m = props.mode;
        if (m === 'combobox') {
            return undefined;
        }
        if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
            return 'combobox';
        }
        return m;
    }, [props.mode]);
    var isMultiple = mode === 'multiple' || mode === 'tags';
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) {
        mergedNotFound = notFoundContent;
    }
    else if (mode === 'combobox') {
        mergedNotFound = null;
    }
    else {
        mergedNotFound = renderEmpty('Select');
    }
    // ===================== Icons =====================
    var _j = (0, iconUtil_1.default)(tslib_1.__assign(tslib_1.__assign({}, props), { multiple: isMultiple, prefixCls: prefixCls, loading: loading })), suffixIcon = _j.suffixIcon, itemIcon = _j.itemIcon, removeIcon = _j.removeIcon, clearIcon = _j.clearIcon;
    var selectProps = (0, omit_1.default)(props, ['suffixIcon', 'itemIcon']);
    var rcSelectRtlDropDownClassName = (0, classnames_1.default)(dropdownClassName, (_b = {},
        _b["".concat(prefixCls, "-dropdown-").concat(direction)] = direction === 'rtl',
        _b));
    var mergedSize = customizeSize || size;
    var mergedClassName = (0, classnames_1.default)((_c = {},
        _c["".concat(prefixCls, "-lg")] = mergedSize === 'large',
        _c["".concat(prefixCls, "-sm")] = mergedSize === 'small',
        _c["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _c["".concat(prefixCls, "-borderless")] = !bordered,
        _c), className);
    return (React.createElement(rc_select_1.default, tslib_1.__assign({ ref: ref, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth }, selectProps, { transitionName: transitionName, listHeight: listHeight, listItemHeight: listItemHeight, mode: mode, prefixCls: prefixCls, direction: direction, inputIcon: suffixIcon, menuItemSelectedIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon, notFoundContent: mergedNotFound, className: mergedClassName, getPopupContainer: getPopupContainer || getContextPopupContainer, dropdownClassName: rcSelectRtlDropDownClassName })));
};
var SelectRef = (0, index_1.default)(React.forwardRef(InternalSelect));
var Select = SelectRef;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = rc_select_1.Option;
Select.OptGroup = rc_select_1.OptGroup;
exports.default = Select;
//# sourceMappingURL=index.js.map